import React, { useEffect, useState } from 'react'
import {
    Box,
    Button,
    Tabs,
    Tab,
    Paper,
    Typography,
    Grid,
    Card,
    CardContent,
    Divider,
    Modal,
    FormControl,
} from "@mui/material";
import { Table, TableBody, TableCell, TableRow } from '@mui/material';
import { GrDocumentText } from "react-icons/gr";
import EastIcon from '@mui/icons-material/East';
import { LiaCalendar } from "react-icons/lia";
import { TfiWorld } from "react-icons/tfi";
import { IoLocationOutline } from "react-icons/io5";
import { RiInformation2Line } from "react-icons/ri";
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import MakePayment from "./MakePayment";
import { CardBody, CardHeader } from 'react-bootstrap';
import { FiCheckCircle } from "react-icons/fi";
import axios from "axios";
import ClearIcon from '@mui/icons-material/Clear';
import environment from "../../environment/environment";
import { Backdrop, CircularProgress } from "@mui/material";
import toast, { Toaster } from 'react-hot-toast';
import TermsAndConditions from './TermsAndConditions ';
import PhoneInput from 'react-phone-input-2';

const priceBreakupModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    maxWidth: "600px",
    height: "auto",
    maxHeight: "90vh",
    bgcolor: "#ffffff",
    border: "1px solid #fff",
    borderRadius: "10px",
    boxShadow: 30,
    p: 4,
    overflowY: "auto",
    "@media (max-width: 600px)": {
        width: "90%",
        maxHeight: "100vh",
        height: '300px',
    },
};

const pricingTableModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "70%",
    maxWidth: "600px",
    height: "auto",
    maxHeight: "90vh",
    bgcolor: "white !important",
    border: "1px solid #fff",
    borderRadius: "10px",
    boxShadow: 30,
    p: 2,
    overflowY: "auto",
    "@media (max-width: 600px)": {
        width: "90%",
        maxHeight: "100vh",
        height: '500px',
    },
};
const BookingSummary = ({ perAdultPriceArray, perChildPriceArray, onNext, onBack, depCity, roomType, formattedDate, adultCount, childCount, infantCount, packageData, activeStep, newPrice, childPrice, perAdultPrice, perChildPrice, travellerDetailsList }) => {
    const [customAmountError, setCustomAmountError] = useState('')
    const steps = [
        {
            id: 1,
            text: "After your payment is complete, our Veena World travel advisor will get in touch with you to complete your booking."
        },
        {
            id: 2,
            text: "Complete details of all travellers including a copy of the valid ID proofs."
        },
        {
            id: 3,
            text: "Post booking confirmation, we are constantly in touch with you through SMS, WhatsApp and email keeping you updated about every step until your departure."
        },
        {
            id: 4,
            text: "Details of the tour manager and all of the pre departure information will be communicated before the departure."
        },
        {
            id: 5,
            text: "Once your tour begins, you can sit back and just enjoy! The Veena World tour manager will handle the rest and ensure that you have a great time!"
        }
    ];
    console.log(packageData);
    const startDate = formattedDate;
    const totalDays = parseInt(packageData?.packageDays) || 0;
    const parsedDate = new Date(formattedDate);
    parsedDate.setDate(parsedDate.getDate() + (totalDays - 1));
    const [acPrice, setAcPrice] = useState('')
    const endDate = parsedDate.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });
    const parseDueDate = new Date(formattedDate);
    parseDueDate.setDate(parseDueDate.getDate() - 7);
    const dueDate = parseDueDate.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });
    // const [packageData, setpackageData] = useState(0);
    const [loading, setLoading] = useState(false);
    const [fullName, setFullName] = useState('');
    const [email, setEmail] = useState('');
    const [mobileNo, setMobileNo] = useState('');
    const [travelDate, setTravelDate] = useState('');
    const [travelCount, setTravelCount] = useState('');
    const [message, setMessage] = useState('');
    const [selectedOption, setSelectedOption] = useState('registration');
    const [selectedTrainOption, setSelectedTrainOption] = useState('NON-AC');
    const [customAmount, setCustomAmount] = useState('');
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [updatesConsent, setUpdatesConsent] = useState(true);
    const [errors, setErrors] = useState({});
    const [igst, setIgst] = useState('');
    const [tcsRate, setTcsRate] = useState('');
    const [grandTotal, setGrandTotal] = useState('');
    const [basicPrice, setBasicPrice] = useState('')
    const [breakPrice, setBreakPrice] = useState('');
    const [totalChildPrice, setTotalChildPrice] = useState('');
    const [totalAdultPrice, setTotalAdultPrice] = useState('');
    // const [gstAmount, setGstAmount] = useState('');
    const [regAmount, setRegAmount] = useState('')
    // const [amountBeforeGst,setAmountBefore]
    const [open, setOpen] = useState(false);
    const [priceTableOpen, setPriceTableOpen] = useState(false)
    const [totalPrice, setTotalPrice] = useState("");
    const [cgst, setCgst] = useState('');
    const [cgstRate,setCgstRate]=useState('');
    const [sgst, setSgst] = useState('');
    const [sgstRate,setSgstRate]=useState('');
    let adultTravellers = 0;
    const paymentDetails = {
        depCity,
        formattedDate,
        termsAccepted,
        regAmount,
        grandTotal,
        selectedTrainOption,
        customAmount,
        selectedOption,
        packageDays:packageData.packageDays,
        packageNight:packageData.packageNight,
        perAdultPrice,
        perChildPrice,
        travellerDetailsList,
        packageUID: packageData?.packageUID,
        packageName: packageData?.packageName,
        paymentMode: 'Online',
        perAdultPriceArray,
        perChildPriceArray,
        ...(selectedTrainOption === 'AC' && {
            acPrice: packageData?.trainUpgradation3AC
        })
    };

    // const totalChildPrice = childCount * childPrice;
    // const amountBeforeGst = grandTotal / 1.05;
    // const gstAmount = grandTotal - amountBeforeGst;
    // const totalAdultPrice = amountBeforeGst /adultCount;
    // useEffect(() => {
    //     const basePrice = newPrice;

    //     calculateTotal(basePrice, adultCount);
    // }, [newPrice])
    useEffect(() => {
        console.log(packageData)
        console.log(perAdultPriceArray)
        console.log(perChildPriceArray)
        adultTravellers = (adultCount ? adultCount : 2) + (childCount ? childCount : 0)
        calculateTotal(newPrice, adultTravellers);
        handleTrainOptionSelect(selectedTrainOption)
        // if (activeStep === 3) {
            getGstDetails()
        // }
    }, [newPrice, activeStep])

    const handleOptionSelect = (option) => {
        setSelectedOption(option);
        if (option === 'full') {
            setCustomAmountError('')
        }
        if (option === 'registration') {
            setCustomAmountError('')
        }
        if (option !== 'custom') {
            setCustomAmount('');
        }
    };

    const handleTrainOptionSelect = (option) => {
        let acPrice = 0
        // const igstRate = 0.05;
        // const igstRate = 5;
        // const tcsRate = 0.10;
        // const igst = newPrice * igstRate;
        // const igst = (newPrice * igstRate )/100;


        // const tcs = newPrice * tcsRate;
        // setTcsRate(tcs)
        acPrice = (Number(adultCount) + Number(childCount)) * packageData?.trainUpgradation3AC;
        let currentTotal = 0;
        if (option === 'AC') {
            // const igstRate = 5;
            // const igst = (((newPrice + acPrice) * igstRate) / 100)
            // setIgst(igst);
            const sgstAmount =(((newPrice + acPrice)* sgst)/100);
            console.log(((newPrice + acPrice)* sgst)/100)
            setSgstRate(sgstAmount);
            const cgstAmount =(((newPrice + acPrice)* cgst)/100);
            console.log(((newPrice + acPrice)* cgst)/100)
            setCgstRate(cgstAmount);
            currentTotal = (newPrice + acPrice) + sgstAmount + cgstAmount;
            // setGstAmount((currentTotal * 5) / 100);
            setRegAmount(currentTotal * 0.3)
        }
        else {
            // const igstRate = 5;
            // const igst = ((newPrice * igstRate) / 100);
            // setIgst(igst);
            const sgstAmount = ((newPrice * sgst) /100 );
            console.log((newPrice * sgst) /100)
            const cgstAmount = ((newPrice * cgst) /100 );  
            console.log((newPrice * cgst) /100 )
            currentTotal = newPrice + sgstAmount + cgstAmount ;
            // setGstAmount(currentTotal - newPrice);
            setCgstRate(sgstAmount);
            setSgstRate(cgstAmount);
            setRegAmount(currentTotal * 0.3);
        }
        setGrandTotal(currentTotal)
        setSelectedTrainOption(option);

    };


    const handleClose = () => {
        setOpen(false);
    }

    const handleOpen = () => {
        setOpen(true);
    };
    const handleOpenPriceTable = () => {
        setPriceTableOpen(true);
    }
    const handleClosePriceTable = () => {
        setPriceTableOpen(false);
    }

    const calculateTotal = (newPrice, adultTravellers) => {
        let grandTotal = 0;
        // const igstRate = 0.05;
        // const tcsRate = 0.10;
        // const igst = newPrice * igstRate;
        // setIgst(igst);
        const cgstRate = (newPrice * cgst)/100;
        setCgstRate(cgstRate)
        console.log(cgstRate);
        const sgstRate = (newPrice * sgst)/100;
        console.log(sgstRate);
        setSgstRate(sgstRate)
        // const tcs = newPrice * tcsRate;
        // setTcsRate(tcs)
        grandTotal = newPrice + cgstRate + sgstRate + acPrice;
        setGrandTotal(grandTotal);
        const breakupPrice = newPrice / adultTravellers;
        setBreakPrice(breakupPrice);
    };

    // const getAmount = () => {
    //     if (selectedOption === 'registration') return '45,000';
    //     if (selectedOption === 'full') return '89,250';
    //     if (selectedOption === 'custom' && customAmount) {
    //         return parseInt(customAmount).toLocaleString('en-IN');
    //     }
    //     return '45,000';
    // };

    // const handleProceed = () => {
    //     if (!termsAccepted) {
    //         toast('Please agree to the Terms and Conditions to proceed.');
    //         return;
    //     }

    //     let amount;
    //     if (selectedOption === 'custom') {
    //         if (!customAmount || customAmount < 45000) {
    //             alert('Please enter a valid amount (minimum ₹45,000)');
    //             return;
    //         }
    //         amount = customAmount;
    //     } else {
    //         amount = selectedOption === 'registration' ? '45000' : '89250';
    //     }

    //     alert(`Processing payment of ₹${parseInt(amount).toLocaleString('en-IN')}`);
    // };

    const handleChangeCustomAmount = (event) => {
        const value = event.target.value;
        const numericValue = Number(value); // convert to number
        console.log(numericValue);
        if (!value || isNaN(numericValue)) {
            setCustomAmountError('Please provide valid information');
        } else if (numericValue < (grandTotal * 0.3)) {
            setCustomAmountError(`Amount should be at least ${Number(grandTotal * 0.3).toFixed(2)}`);
        } else if (numericValue > grandTotal) {
            setCustomAmountError(`Amount should not exceed ${Number(grandTotal).toFixed(2)}`);
        } else {
            setCustomAmountError('');
        }

        setCustomAmount(value);
        console.log('Value:', value);
    };


    const validateForm = () => {
        const newErrors = {};
        if (!fullName.trim()) newErrors.fullName = 'Full Name is required';
        if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            newErrors.email = 'Valid Email is required';
        }
        if (!mobileNo.trim()) {
            newErrors.mobileNo = 'Mobile No. is required';
        } else if (!/^\d{10}$/.test(mobileNo)) {
            newErrors.mobileNo = 'Mobile No. must be exactly 10 digits';
        }
        if (!travelDate) newErrors.travelDate = 'Travel Date is required';
        if (!travelCount) newErrors.travelCount = 'Traveller Count is required';
        if (!message.trim()) newErrors.message = 'Message is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (field, value) => {
        switch (field) {
            case 'fullName':
                setFullName(value);
                break;
            case 'email':
                setEmail(value);
                break;
            case 'mobileNo':
                setMobileNo(value);
                break;
            case 'travelDate':
                setTravelDate(value);
                break;
            case 'travelCount':
                setTravelCount(value);
                break;
            case 'message':
                setMessage(value);
                break;
            default:
                break;
        }

        if (errors[field]) {
            setErrors((prevErrors) => ({ ...prevErrors, [field]: '' }));
        }
    };
    const handleCancel = () => {
        setEmail('')
        setErrors({})
        setFullName('')
        setMessage('')
        setMobileNo('')
        setTravelDate('')
        setTravelCount('')

    }

    const sendEnquiry = () => {
        if (!validateForm()) {
            // toast.error('Please Enter Valid Details To Connect With An Experts!')
            return;  // Do not proceed if validation fails
        }

        const requestBody = {
            "fullName": fullName,
            "email": email,
            "phoneNumber": mobileNo,
            "travelDate": travelDate,
            "travellerCount": travelCount,
            "message": message,
            "type": "website"
        };

        setLoading(true);
        axios({
            url: `${environment.config.apiBaseUrl}enquiry/createEnquiryDeatils`,
            method: "POST",
            headers: {
                authorization: "your token comes here",
            },
            data: requestBody
        })
            .then((res) => {
                setLoading(false);
                if (res && res.data) {
                    document.getElementById("exampleModal").classList.remove("show", "d-block");
                    document.querySelectorAll(".modal-backdrop")
                        .forEach(el => el.classList.remove("modal-backdrop"));
                }
            })
            .catch(() => { setLoading(false); });
        setFullName('');
        setEmail('');
        setMessage('');
        setTravelCount('');
        setTravelDate('');
        setMessage('');
        setMobileNo('')
    };

    const getGstDetails = () => {
        axios({
            url: `${environment.config.apiOrderUrl}tax/getAllTaxDetails?pageNo=0&pageSize=10`,
            method: "GET",
            headers: {
                authorization: "your token comes here",
            },
        })
            .then((res) => {
                if (res && res.data) {
                    console.log(res.data.taxDetails[0])
                    setCgst(res.data.taxDetails[0].igst);
                    setSgst(res.data.taxDetails[0].sgst)
                }
            })
            .catch((error) => {
                // toast.error("Failed to load package details. Please try again later.");
            })
    }


    return (
        <div>
            <Toaster
                position="top-right"
                reverseOrder={false}
            />
            {(activeStep === 0 || activeStep === 1) &&
                <Card sx={{ display: 'flex', flexDirection: 'column', padding: 4, borderRadius: 2, minHeight: '420px' }}>
                    <Typography sx={{ fontWeight: '600' }}><GrDocumentText className='me-2' />Booking Summary</Typography>
                    <hr></hr>
                    <ul style={{ fontSize: '13px', listStyle: 'none', padding: 0, lineHeight: 3 }}>
                        <li className="d-flex flex-row">
                            <div className="col-md-4 col-4">Dept. City</div>
                            <div className="col-md-8 col-8" style={{ textTransform: 'capitalize' }}><strong>{depCity || ''}</strong></div>
                        </li>
                        <li className="d-flex flex-row">
                            <div className="col-md-4 col-4">Dept. Date</div>
                            {formattedDate && (
                                <div className="col-md-8 col-8"><strong>{formattedDate} <EastIcon sx={{ fontSize: '16px' }} /> {endDate}</strong>
                                    {activeStep === 1 ? (
                                        <button
                                            type="button"
                                            data-bs-toggle="tooltip"
                                            title="Edit Task"
                                            className="btn btn-link btn-md"
                                            style={{ padding: '5px 0px 8px 5px', boxShadow: 'none' }}
                                            onClick={onBack}
                                        >
                                            <i className="fa fa-edit"></i>
                                        </button>
                                    ) : ('')}
                                </div>
                            )}

                        </li>
                        <li className="d-flex flex-row">
                            <div className="col-md-4 col-4">Travellers</div>
                            <div className="col-md-8 col-8">
                                {activeStep === 0 ? (
                                    <div>Adults (0),Child(0),Infant(0)</div>
                                ) : (
                                    <div className="traveller-pricing-summary">

                                        {/* Adults */}
                                        {perAdultPriceArray.map((price, index) => (
                                            <div key={`adult-${index}`} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <strong style={{ fontWeight: '600', fontSize: '13px' }}>Adult {index + 1}</strong>
                                                <strong style={{ fontWeight: '600', fontSize: '13px' }}>₹{price}</strong>
                                            </div>
                                        ))}

                                        {/* Children */}
                                        {perChildPriceArray.map((price, index) => (
                                            <div key={`child-${index}`} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <strong style={{ fontWeight: '600', fontSize: '13px' }}>Child {index + 1}</strong>
                                                <strong style={{ fontWeight: '600', fontSize: '13px' }}>₹{price}</strong>
                                            </div>
                                        ))}

                                        {/* Infants */}
                                        {infantCount > 0 && (
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <strong style={{ fontWeight: '600', fontSize: '13px' }}>Infants ({infantCount})</strong>
                                                <strong style={{ fontWeight: '600', fontSize: '13px' }}>Free</strong>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </li>
                        <li className="d-flex flex-row">
                            <div className="col-md-4 col-4">Rooms</div>
                            <div className="col-md-8 col-8">
                                {activeStep === 0 &&
                                    <div>0 Rooms</div>
                                }
                                <strong>{roomType}</strong>
                            </div>
                        </li>
                    </ul>
                    <Divider></Divider>
                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: 5 }}>
                        {/* <div className='d-flex align-items-start'>
                        </div> */}
                        <div className='d-flex align-items-start flex-column'>
                            <div className='text-start'>Basic Price</div>
                            {/* <button className='d-flex justify-content-center align-items-center' style={{ fontSize: '14px', margin: '0px', fontWeight: '600px', padding: 0, margin: 0, border: 'none', cursor: 'pointer', textDecoration: 'underline', color: '#2d2b29', background: 'transparant', backgroundColor: 'none' }} onClick={handleOpenPriceTable}>View Pricing Table</button> */}
                            <button type="button" class="btn" data-bs-toggle="modal" data-bs-target="#viewPriceModal" style={{ fontSize: '14px', margin: '0px', fontWeight: '600px', padding: 0, margin: 0, border: 'none', cursor: 'pointer', textDecoration: 'underline', color: '#2d2b29', background: 'transparant', boxShadow: 'none' }}>
                                View Pricing Table
                            </button>
                        </div>
                        <div className='d-flex flex-column align-items-end'>
                            {depCity === 'Joining/Leaving' ? (
                                <div style={{ fontSize: '18px', fontWeight: '600px', color: 'green', padding: 0, margin: 0 }}>&#8377; {
                                    activeStep === 0
                                        ? packageData?.roomDetails?.find(room => room.roomType === 'Quad Sharing (4 Person In One Room)')?.packageCostForJoinLeave
                                        : newPrice
                                }</div>
                            ) : (
                                <div style={{ fontSize: '18px', fontWeight: '600px', color: 'green', padding: 0, margin: 0 }}>&#8377; {
                                    activeStep === 0
                                        ? packageData?.roomDetails?.find(room => room.roomType === 'Quad Sharing (4 Person In One Room)')?.roomPrice
                                        : newPrice
                                }</div>
                            )}
                            {activeStep === 0 ? (
                                <div style={{ fontSize: '10px', padding: 0, margin: 0 }}>Per person on quad sharing</div>

                            ) : (
                                <div style={{ fontSize: '10px', padding: 0, margin: 0 }}>*Excludes taxes</div>
                            )}
                        </div>
                    </Box>
                    <div className='d-flex flex-row' style={{ gap: 5, marginTop: 5 }}>
                        <div className='col-md-6 col-6'>
                            <button type="button" className="btn btn-color bt-width btn-mobile" data-bs-toggle="modal"
                                data-bs-target="#exampleModal" style={{ fontSize: '12px', fontWeight: '600', boxShadow: 'none' }}>Send Enquiry</button>
                        </div>
                        <div className='col-md-6 col-6'>
                            {activeStep === 0 ? (
                                <Button onClick={onNext} sx={{ backgroundColor: '#fff099', borderRadius: 2, color: '#2d2b29', height: '100%', width: '100%', textTransform: 'capitalize', fontSize: '12px', fontWeight: '600' }}>
                                    Add Guests & Rooms
                                    {/* <EastIcon sx={{ fontSize: '20px' }} /> */}
                                </Button>
                            ) : (
                                <Button onClick={onNext} sx={{ backgroundColor: '#fff099', borderRadius: 2, color: '#2d2b29', height: '100%', width: '100%', textTransform: 'capitalize', fontSize: '12px', fontWeight: '600' }} disabled={(activeStep === 3) || (adultCount + childCount + infantCount > 10)}>
                                    Add Traveller Details
                                    {/* <EastIcon sx={{ fontSize: '12px' }} /> */}
                                </Button>
                            )}
                        </div>
                    </div>
                </Card>
            }
            {activeStep === 2 &&
                <Card sx={{ display: 'flex', flexDirection: 'column', gap: 2, padding: 4, borderRadius: 2, minHeight: '555px' }}>
                    <Typography sx={{ fontSize: '14px' }}>Your tour highlights</Typography>
                    <div className='booking-packageName mb-2' style={{ fontWeight: 700, fontSize: '14px' }}>{packageData?.packageName}</div>
                    <div className='d-flex flex-row justify-content-between align-items-center'>
                        <div className='d-flex'><LiaCalendar style={{ fontSize: '25px' }} />{packageData?.packageDays} Days</div>
                        <div className='d-flex'><TfiWorld style={{ fontSize: '20px', marginRight: 2 }} /> 1 Country</div>
                        <div className='d-flex'><IoLocationOutline style={{ fontSize: '22px' }} />{packageData?.routeDestination.length}Cities</div>
                    </div>
                    <Divider></Divider>
                    <div className='d-flex flex-row justify-content-between align-items-center'>
                        <div className="d-flex flex-column justify-content-content">
                            <div style={{ fontSize: '12px' }}>Tour starts<Tooltip style={{ fontSize: '12px', }} title="The flight departure date can often be one day prior to the tour start date." placement='bottom-start' arrow>
                                <IconButton>
                                    <RiInformation2Line style={{ color: 'blue', fontSize: '15px' }} />
                                </IconButton>
                            </Tooltip></div>
                            <div style={{ fontSize: '12px', fontWeight: 600 }}>{formattedDate}</div>
                            <div style={{ fontSize: '12px', textTransform: 'capitalize' }}>{depCity}</div>
                        </div>
                        <div><EastIcon sx={{ fontSize: '16px' }} /></div>
                        <div className='d-flex flex-column'>
                            <div style={{ fontSize: '12px' }}>Tour ends</div>
                            <div style={{ fontSize: '12px', fontWeight: 600 }}>{endDate}</div>
                            <div style={{ fontSize: '12px', textTransform: 'capitalize' }}>{depCity}</div>
                        </div>
                    </div>
                    <Divider></Divider>
                    <div className='d-flex flex-column'>
                        <div className='d-flex flex-row justify-content-between align-items-center'>
                            <div style={{ fontSize: '12px' }}>Travellers & Room</div>
                            <div>
                                {activeStep === 2 ? (
                                    <button
                                        type="button"
                                        data-bs-toggle="tooltip"
                                        title="Edit Task"
                                        className="btn btn-link btn-md"
                                        style={{ padding: '5px 0px 8px 5px', boxShadow: 'none' }}
                                        onClick={onBack}
                                    >
                                        <i className="fa fa-edit"></i>
                                    </button>
                                ) : ('')}
                            </div>
                        </div>
                        {/* <div className='d-flex flex-row' style={{ fontSize: '14px', fontWeight: '500' }}>
                            <div>{adultCount} Adult</div>,
                            <div>{childCount} Child</div>,
                            <div>{infantCount} Infant</div>
                        </div> */}
                        <div className="traveller-pricing-summary">

                            {/* Adults */}
                            {perAdultPriceArray.map((price, index) => (
                                <div key={`adult-${index}`} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <span style={{ fontWeight: '600' }}>Adult {index + 1}</span>
                                    <span style={{ fontWeight: '600' }}>₹{price}</span>
                                </div>
                            ))}

                            {/* Children */}
                            {perChildPriceArray.map((price, index) => (
                                <div key={`child-${index}`} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <span style={{ fontWeight: '600' }}>Child {index + 1}</span>
                                    <span style={{ fontWeight: '600' }}>₹{price}</span>
                                </div>
                            ))}

                            {/* Infants */}
                            {infantCount > 0 && (
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <span>Infants ({infantCount})</span>
                                    <span>Free</span>
                                </div>
                            )}
                        </div>
                        <div className='' style={{ fontSize: '14px', fontWeight: '500' }}>
                            <div>{roomType}</div>
                        </div>
                    </div>
                    <Divider />
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', height: '60px', backgroundColor: '#1976d2', padding: 10, borderRadius: 5 }}>
                        <div className='d-flex flex-column align-items-start'>
                            {/* <button style={{ fontSize: '14px', fontWeight: '600px', padding: 0, margin: 0, border: 'none', backgroundColor: '#fff099', cursor: 'pointer', textDecoration: 'underline' }} onClick={handleOpen}>Price breakup</button> */}
                            <div style={{ fontSize: '14px', fontWeight: '600px', padding: 0, margin: 0, border: 'none', backgroundColor: '#1976d2', color: 'white' }}>Price</div>
                            {/* <button className='d-flex justify-content-center align-items-center' style={{ fontSize: '14px', margin: '0px', fontWeight: '600px', padding: 0, margin: 0, border: 'none', cursor: 'pointer', textDecoration: 'underline', color: 'white', backgroundColor: '#1976d2' }} onClick={handleOpenPriceTable}>View Pricing Table</button> */}
                            <button type="button" class="btn" data-bs-toggle="modal" data-bs-target="#viewPriceModal" style={{ fontSize: '14px', margin: '0px', fontWeight: '600px', padding: 0, margin: 0, border: 'none', cursor: 'pointer', textDecoration: 'underline', color: 'white', background: 'transparant', boxShadow: 'none' }}>
                                View Pricing Table
                            </button>
                        </div>
                        <div className='d-flex align-items-center' style={{ backgroundColor: '#1976d2' }}>
                            <div style={{ fontSize: '20px', fontWeight: '600px', color: 'white', padding: 0, margin: 0 }}> &#8377; {newPrice}*</div>
                        </div>
                    </div>
                    <div style={{ height: '100%' }}>
                        {activeStep === 2 ? (
                            <Button onClick={onNext} sx={{ backgroundColor: '#fff099', borderRadius: 2, color: '#2d2b29', height: '100%', width: '100%', textTransform: 'capitalize', fontSize: '14px', fontWeight: '600' }}>
                                Preview Details
                                {/* <EastIcon sx={{ fontSize: '20px' }} /> */}
                            </Button>
                        ) : ('')}
                    </div>
                </Card>
            }
            {activeStep === 3 &&
                <Card sx={{ display: 'flex', flexDirection: 'column', gap: 2, padding: 4, borderRadius: 2 }}>
                    <div className='d-flex flex-column justify-content-between align-items-start mt-3'>
                        <div>Train Upgradation<Tooltip style={{ fontSize: '12px', }} title="With this package, we are providing non-AC sleeper seats. If you wish to upgrade, you can choose 3AC, but additional charges will apply." placement='bottom-start' arrow>
                            <IconButton>
                                <RiInformation2Line style={{ color: 'blue', fontSize: '15px' }} />
                            </IconButton>
                        </Tooltip>
                        </div>
                        <div className="flex flex-col">
                            <div
                                className="flex items-center justify-between mb-2 border-b border-gray-200 cursor-pointer hover:bg-gray-50 px-6"
                                onClick={() => handleTrainOptionSelect('NON-AC')}
                            >
                                <div className="flex items-center gap-3">
                                    <input
                                        type="radio"
                                        name="train"
                                        value="NON-AC"
                                        checked={selectedTrainOption === 'NON-AC'}
                                        onChange={() => handleTrainOptionSelect('NON-AC')}
                                        className="form-radio text-blue-600 h-5 w-5 cursor-pointer"
                                        style={{ marginRight: '15px' }}
                                    />
                                    <label className="text-base font-medium text-gray-700 cursor-pointer">
                                        NON-AC (Sleeper)
                                    </label>
                                </div>
                            </div>

                            <div
                                className="flex items-center justify-between mb-2 border-b border-gray-200 cursor-pointer hover:bg-gray-50 px-6"
                                onClick={() => handleTrainOptionSelect('AC')}
                            >
                                <div className="flex items-center gap-3">
                                    <input
                                        type="radio"
                                        name="train"
                                        value="AC"
                                        checked={selectedTrainOption === 'AC'}
                                        onChange={() => handleTrainOptionSelect('AC')}
                                        className="form-radio text-blue-600 h-5 w-5 cursor-pointer"
                                        style={{ marginRight: '15px' }}
                                    />
                                    <label className="text-base font-medium text-gray-700 cursor-pointer">
                                        AC (3 tier)
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Divider></Divider>
                    <div className='d-flex flex-column'>
                        <div
                            className="d-flex flex-row align-items-center justify-content-between mb-3 border-b border-gray-200 cursor-pointer hover:bg-gray-50 -mx-6 px-6"
                            onClick={() => handleOptionSelect('registration')}
                        >
                            <div className="d-flex align-items-center gap-3">
                                <input
                                    type="radio"
                                    name="payment"
                                    checked={selectedOption === 'registration'}
                                    onChange={() => handleOptionSelect('registration')}
                                    className="w-5 h-5 text-blue-600 cursor-pointer"
                                />
                                <label className="text-base font-medium text-gray-700 cursor-pointer">
                                    Pay Registration Amount
                                </label>
                            </div>
                            <div className="text-lg font-semibold text-gray-800">&#8377;{Number(((grandTotal) * 0.3)).toFixed(2)}</div>
                            {/* {acPrice ? (
                                <div className="text-lg font-semibold text-gray-800">&#8377;{((acPrice) * 0.3) / 2}</div>
                            ):(
                                <div className="text-lg font-semibold text-gray-800">&#8377;{((newPrice) * 0.3) / 2} </div>
                            )} */}
                        </div>
                        <div
                            className="d-flex flex-row align-items-center justify-content-between mb-3  border-b border-gray-200 cursor-pointer hover:bg-gray-50 -mx-6 px-6"
                            onClick={() => handleOptionSelect('full')}
                        >
                            <div className="d-flex align-items-center gap-3">
                                <input
                                    type="radio"
                                    name="payment"
                                    checked={selectedOption === 'full'}
                                    onChange={() => handleOptionSelect('full')}
                                    className="w-5 h-5 text-blue-600 cursor-pointer"
                                />
                                <label className="text-base font-medium text-gray-700 cursor-pointer">
                                    Pay Full Amount
                                </label>
                            </div>
                            <div className="text-lg font-semibold text-gray-800">&#8377; {Number(grandTotal).toFixed(2)}</div>
                            {/* {acPrice ? (
                                 <div className="text-lg font-semibold text-gray-800">&#8377; {acPrice}</div>
                            ):(
                                <div className="text-lg font-semibold text-gray-800">&#8377; {newPrice}</div>
                            )} */}

                        </div>
                        <div
                            className="d-flex flex-row align-items-center justify-content-between mb-1 cursor-pointer hover:bg-gray-50 -mx-6 px-6"
                            onClick={() => handleOptionSelect('custom')}
                        >
                            <div className="d-flex align-items-center gap-3">
                                <input
                                    type="radio"
                                    name="payment"
                                    checked={selectedOption === 'custom'}
                                    onChange={() => handleOptionSelect('custom')}
                                    className="w-5 h-5 text-blue-600 cursor-pointer"

                                />
                                <label className="text-base font-medium text-gray-700 cursor-pointer">
                                    Pay Custom Amount
                                </label>
                            </div>
                            <input
                                type="number"
                                value={customAmount}
                                onChange={handleChangeCustomAmount}
                                placeholder={`Min ${Number(((grandTotal) * 0.3)).toFixed(2)}`}
                                className={`w-48 px-2 py-1 border-2 rounded-md text-base ${selectedOption === 'custom'
                                    ? 'bg-white border-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-opacity-20'
                                    : 'bg-gray-100 border-gray-300'
                                    }`}
                                style={{ width: '125px' }}
                            />
                        </div>
                        {customAmountError && <p style={{ color: 'red', fontSize: '12px' }}>{customAmountError}</p>}
                        {(selectedOption === 'registration' || selectedOption === 'custom') &&
                            <div style={{ fontSize: '12px' }}>Balance Payment due by {dueDate}</div>
                        }
                    </div>
                    <Divider />
                    <div className="px-6 pb-6">
                        <div className="d-flex align-items-start gap-3 mb-2">
                            <input
                                type="checkbox"
                                id="terms"
                                checked={termsAccepted}
                                onChange={(e) => setTermsAccepted(e.target.checked)}
                                className="w-4 h-4 text-blue-600 mt-1 cursor-pointer"
                            />
                            <label htmlFor="terms" className="text-sm text-gray-600 leading-relaxed cursor-pointer">
                                I agree to the{' '}
                                {/* <a style={{ textDecoration: 'none' }} href="#" className="text-blue-600 hover:underline">
                                    Terms and Conditions
                                </a>{' '} */}
                                <button type="button" class="btn " data-bs-toggle="modal" data-bs-target="#termsandconditions" style={{ fontSize: '13px', color: 'blue', margin: 0, padding: 0, boxShadow: 'none' }}>
                                    Terms and Conditions
                                </button>
                                and have reviewed the  Policies and Cancellation rules.
                            </label>
                        </div>
                        <div className="d-flex align-items-start gap-3 mb-2">
                            <input
                                type="checkbox"
                                id="updates"
                                checked={updatesConsent}
                                onChange={(e) => setUpdatesConsent(e.target.checked)}
                                className="w-4 h-4 text-blue-600 mt-1 cursor-pointer"
                            />
                            <label htmlFor="updates" className="text-sm text-gray-600 leading-relaxed cursor-pointer">
                                I consent to receiving updates regarding my trip on SMS, RCS, email & Whatsapp
                            </label>
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: '#294992', padding: 10, borderRadius: 5, height: '60px', color: 'white' }}>
                        <div className='d-flex align-items-end '>
                            <button type="button" class="btn" data-bs-toggle="modal" data-bs-target="#priceBreakupModal" style={{ fontSize: '14px', margin: '0px', fontWeight: '600px', padding: 0, margin: 0, border: 'none', cursor: 'pointer', textDecoration: 'underline', color: 'white', background: 'transparant', boxShadow: 'none' }}>
                                Pricing breakup
                            </button>
                        </div>
                        <div className='d-flex align-items-end flex-column justify-content-end'>
                            <div>Grand Total</div>
                            <div style={{ fontSize: '20px', fontWeight: '700px', color: 'white', padding: 0, margin: 0 }}> &#8377;{Number(grandTotal).toFixed(2)}*</div>
                        </div>
                    </div>
                    <MakePayment paymentDetails={paymentDetails} termsAccepted={termsAccepted} regAmount={regAmount} grandTotal={grandTotal} selectedTrainOption={selectedTrainOption} customAmount={customAmount} selectedOption={selectedOption} />
                </Card>
            }
            <Card sx={{ display: 'flex', flexDirection: 'column', gap: 2, padding: 2, borderRadius: 2, mt: 1 }}>
                <CardHeader style={{ backgroundColor: 'white', fontSize: '16px', display: 'flex', justifyContent: 'start', padding: '.5rem 0rem .5rem 0rem', fontWeight: '600' }}>Once you book, we’ll handle the rest.</CardHeader>
                <CardBody>
                    {steps.map((step) => (
                        <div key={step.id} className="d-flex flex-row gap-2">
                            <div className='col-md-1 p-0'>
                                <FiCheckCircle size={15} className="text-warning" />
                            </div>
                            <div className='col-md-10 p-0'>
                                <p style={{ fontSize: '13px' }}>{step.text}</p>
                            </div>
                        </div>
                    ))}
                </CardBody>
            </Card>
            <div className="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-scrollable modal-down">
                    <div className="modal-content modal-content-overflow">

                        <div className="modal-header">
                            <div className="container modal-heading-section">


                                <div className="row">
                                    <div className="col-3">
                                        <img src={packageData?.length > 0 && packageData?.imageList[0]?.coverImage} alt="" className="rounded mx-auto d-block " width="50"
                                            height="50" />
                                    </div>
                                    <div className="col-9">
                                        <h5 className="card-text bold" style={{ fontSize: '12px' }}>{packageData?.packageName}</h5>
                                        <p className="card-text">
                                            <b className="me-2 package-title-prices">INR {packageData?.packageWithDiscountPrices ? new Intl.NumberFormat('en-IN').format(packageData?.packageWithDiscountPrices) : 0}
                                            </b>
                                            <span className="package-price-decoration me-1">INR
                                                {packageData?.packagePrices ? new Intl.NumberFormat('en-IN').format(packageData?.packagePrices) : 0}</span>
                                            <span className="title-prices">
                                                SAVE INR  {packageData?.savePrices ? new Intl.NumberFormat('en-IN').format(packageData?.savePrices) : 0}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <button
                                type="button"
                                className="customer-close-btn"
                                onClick={handleCancel}
                                data-bs-dismiss="modal"
                            >
                                {" "}
                                &times;
                            </button>

                        </div>

                        <div className="modal-body">
                            <>
                                <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={loading}>
                                    <CircularProgress color="inherit" />
                                </Backdrop>
                                <form className="form-modal-wraaper mt-1">
                                    <div className="form-floating mb-3">
                                        <input
                                            type="text"
                                            className={`form-control ${errors.fullName ? 'is-invalid' : ''}`}
                                            placeholder="Full Name"
                                            value={fullName}
                                            onChange={(e) => handleChange('fullName', e.target.value)}
                                        />
                                        <label>Full Name *</label>
                                        {errors.fullName && <div className="invalid-feedback">{errors.fullName}</div>}
                                    </div>
                                    <div className="form-floating mb-3">
                                        <input
                                            type="email"
                                            className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                            placeholder="name@example.com"
                                            value={email}
                                            onChange={(e) => handleChange('email', e.target.value)}
                                        />
                                        <label>Email* </label>
                                        {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                                    </div>
                                    {/* <div className="form-floating mb-3">
                                        <input
                                            type="text"
                                            className={`form-control ${errors.mobileNo ? 'is-invalid' : ''}`}
                                            placeholder="+91 xxx xxxx xxx"
                                            value={mobileNo}
                                            pattern="\d{10}"
                                            minLength={10}
                                            maxLength={10}
                                            onChange={(e) => handleChange('mobileNo', e.target.value)}
                                        />
                                        <label>Mobile No.*</label>
                                        {errors.mobileNo && <div className="invalid-feedback">{errors.mobileNo}</div>}
                                    </div> */}
                                    <div className="form-floating mb-3">
                                        <PhoneInput
                                            country={'in'}
                                            value={mobileNo}
                                            onChange={(value) => handleChange('mobileNo', value)}
                                            inputStyle={{ width: '100%', height: '55px' }}
                                            countryCodeEditable={false}
                                        />
                                        {errors.mobileNo && (
                                            <div className="invalid-feedback" style={{ display: 'block' }}>
                                                {errors.mobileNo}
                                            </div>
                                        )}                                    </div>

                                    <div className="row align-self-center">
                                        <div className="col-md-6 mt-1">
                                            <div className="form-floating mb-3">
                                                <input
                                                    type="date"
                                                    className={`form-control ${errors.travelDate ? 'is-invalid' : ''}`}
                                                    placeholder="Travel Date"
                                                    value={travelDate}
                                                    min={new Date().toISOString().split('T')[0]}  // Setting min date to today
                                                    max={new Date(new Date().getFullYear() + 1, 11, 31).toISOString().split('T')[0]} // Setting max to last day of next year
                                                    onChange={(e) => handleChange('travelDate', e.target.value)}
                                                />
                                                <label>Travel Date*</label>
                                                {errors.travelDate && <div className="invalid-feedback">{errors.travelDate}</div>}
                                            </div>
                                        </div>


                                        <div className="col-md-6 mt-1">
                                            <div className="form-floating mb-3">
                                                <input
                                                    type="number"
                                                    className={`form-control ${errors.travelCount ? 'is-invalid' : ''}`}
                                                    placeholder="Traveller Count"
                                                    value={travelCount}
                                                    onChange={(e) => handleChange('travelCount', e.target.value)}
                                                    min={1}
                                                    max={5}
                                                />
                                                <label>Traveller Count*</label>
                                                {errors.travelCount && <div className="invalid-feedback">{errors.travelCount}</div>}
                                            </div>
                                        </div>
                                        <div className="form-floating mb-3">

                                            <textarea
                                                className={`form-control ${errors.message ? 'is-invalid' : ''}`}
                                                placeholder="Message"
                                                value={message}
                                                rows={4}
                                                onChange={(e) => handleChange('message', e.target.value)}
                                                style={{ minHeight: '100px' }}
                                            />
                                            <label className="message-placeholder">Your Requirements *</label>
                                            {errors.message && <div className="invalid-feedback">{errors.message}</div>}
                                        </div>
                                    </div>
                                </form>
                            </>
                        </div>
                        <hr className="mt-margin" />
                        <div className="modal-footer">
                            <button type="button" className="btn btn-color bt-width" style={{ backgroundColor: '#fff099', border: 'none' }} onClick={sendEnquiry}>Connect with an Expert</button>
                        </div>
                    </div>
                </div>
            </div>
            {/* <Modal open={open} aria-labelledby="modal-modal-title">
                <Box sx={priceBreakupModal}>
                    <Typography className='d-flex flex-row justify-content-between' id="modal-modal-title" variant="h6" component="h2">
                        <strong ><span style={{
                            color: "#32325d",
                            textDecoration: "underline",
                            textDecorationColor: "yellow",
                            textDecorationThickness: "2px",
                            textUnderlineOffset: '4px'
                        }}>
                            Detailed Pr
                        </span>ice breakup</strong>

                        <Button variant="text" color="inherit" onClick={handleClose}>
                            <ClearIcon />
                        </Button>
                    </Typography>
                    <div className="container mt-3">
                        <div className="container-fluid">
                            <div className="row">
                                {Array.isArray(travellerDetailsList[0]?.adultDetails) &&
                                    travellerDetailsList[0]?.adultDetails.map((item, index) => (
                                        <React.Fragment key={index}>
                                            <div className="traveller-price mt-2 d-flex flex-row justify-content-between gap-3">
                                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                                    <strong style={{ fontSize: '14px', marginRight: '10px' }}>Adult {index + 1}</strong>
                                                    <span>{`(${item.firstName})`}</span>
                                                </div>
                                                <div>₹{Number(perAdultPriceArray?.[index] ?? 0).toFixed(2)}</div>
                                            </div>

                                            {selectedTrainOption === 'AC' && (
                                                <div className="traveller-price mt-2 d-flex flex-row justify-content-between gap-3">
                                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                        <strong style={{ fontSize: '14px' }}>AC (3 tier)</strong>
                                                    </div>
                                                    <div>₹{Number(packageData?.trainUpgradation3AC).toFixed(2)}</div>
                                                </div>
                                            )}

                                            <Divider className="mt-1 mb-1" />
                                        </React.Fragment>
                                    ))}
                                {childCount > 0 && Array.isArray(travellerDetailsList[0]?.childDOB) &&
                                    travellerDetailsList[0]?.childDOB.map((item, index) => (
                                        <React.Fragment key={index}>
                                            <div className="traveller-price mt-2 d-flex flex-row justify-content-between gap-3">
                                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                                    <strong style={{ fontSize: '14px', marginRight: '10px' }}>Child {index + 1}</strong>
                                                    <span>{`(${item.firstName})`}</span>
                                                </div>
                                                <div>₹{Number(perChildPriceArray?.[index]).toFixed(2)}</div>
                                            </div>

                                            {selectedTrainOption === 'AC' && (
                                                <div className="traveller-price mt-2 d-flex flex-row justify-content-between gap-3">
                                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                        <strong style={{ fontSize: '14px' }}>AC (3 tier)</strong>
                                                    </div>
                                                    <div>₹{Number(packageData?.trainUpgradation3AC).toFixed(2)}</div>
                                                </div>
                                            )}

                                            <Divider className="mt-1 mb-1" />
                                        </React.Fragment>
                                    ))}

                                <div className='d-flex flex-column gap-3'>
                                    <div className='subTotal-taxes mb-2 d-flex flex-row justify-content-between'>
                                        <div> Sub Total(All Travellers):</div>
                                        <div> <strong>₹{Number(newPrice).toFixed(2)}</strong></div>
                                    </div>
                                    <div className='subTotal-taxes mt-2 mb-2 d-flex flex-row justify-content-between'>
                                        <div> IGST @5%</div>
                                        <div> +₹{Number(igst).toFixed(2)}</div>
                                    </div>
                                    <div className='subTotal-taxes mt-2 mb-2 d-flex flex-row justify-content-between'>
                                        <div> TCS @10%</div>
                                        <div> +₹{tcsRate}</div>
                                    </div>
                                </div>
                                <hr className='mt-2 mb-2'></hr>
                                <div className="total-payable d-flex flex-row justify-content-between gap-3">
                                    <div>Total Payable</div>
                                    <div style={{ color: 'green', fontWeight: '600' }}>₹{Number(grandTotal).toFixed(2)}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Box>
            </Modal> */}
            <div className="modal fade" id="priceBreakupModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered">
                    <div className="modal-content modal-content-overflow">
                        <div className="modal-header">
                            <div className="container modal-heading-section">
                                <div className="row">
                                    <div className="d-flex flex-column justify-content-start alig-items-center">
                                        <div style={{ fontSize: '18px', color: '#2d2b29' }}>Price Breakup</div>
                                    </div>
                                </div>
                            </div>

                            <button
                                type="button"
                                className="customer-close-btn"
                                onClick={handleCancel}
                                data-bs-dismiss="modal"
                            >
                                {" "}
                                &times;
                            </button>

                        </div>
                        <div className="modal-body">
                            <div className="container mt-3">
                                <div className="container-fluid">
                                    <div className="row">
                                        {Array.isArray(travellerDetailsList[0]?.adultDetails) &&
                                            travellerDetailsList[0]?.adultDetails.map((item, index) => (
                                                <React.Fragment key={index}>
                                                    <div className="traveller-price mt-2 d-flex flex-row justify-content-between gap-3">
                                                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                                                            <strong style={{ fontSize: '14px', marginRight: '10px' }}>Adult {index + 1}</strong>
                                                            <span>{`(${item.firstName})`}</span>
                                                        </div>
                                                        <div>₹{Number(perAdultPriceArray?.[index] ?? 0).toFixed(2)}</div>
                                                    </div>

                                                    {selectedTrainOption === 'AC' && (
                                                        <div className="traveller-price mt-2 d-flex flex-row justify-content-between gap-3">
                                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                <strong style={{ fontSize: '14px' }}>AC (3 tier)</strong>
                                                            </div>
                                                            <div>₹{Number(packageData?.trainUpgradation3AC).toFixed(2)}</div>
                                                        </div>
                                                    )}

                                                    <Divider className="mt-1 mb-1" />
                                                </React.Fragment>
                                            ))}
                                        {childCount > 0 && Array.isArray(travellerDetailsList[0]?.childDOB) &&
                                            travellerDetailsList[0]?.childDOB.map((item, index) => (
                                                <React.Fragment key={index}>
                                                    <div className="traveller-price mt-2 d-flex flex-row justify-content-between gap-3">
                                                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                                                            <strong style={{ fontSize: '14px', marginRight: '10px' }}>Child {index + 1}</strong>
                                                            <span>{`(${item.firstName})`}</span>
                                                        </div>
                                                        <div>₹{Number(perChildPriceArray?.[index]).toFixed(2)}</div>
                                                    </div>

                                                    {selectedTrainOption === 'AC' && (
                                                        <div className="traveller-price mt-2 d-flex flex-row justify-content-between gap-3">
                                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                <strong style={{ fontSize: '14px' }}>AC (3 tier)</strong>
                                                            </div>
                                                            <div>₹{Number(packageData?.trainUpgradation3AC).toFixed(2)}</div>
                                                        </div>
                                                    )}

                                                    <Divider className="mt-1 mb-1" />
                                                </React.Fragment>
                                            ))}

                                        {/* <hr className='mt-2 mb-2'></hr> */}
                                        <div className='d-flex flex-column gap-3'>
                                            <div className='subTotal-taxes mb-2 d-flex flex-row justify-content-between'>
                                                {/* <div> Sub Total(All Travellers):</div> */}
                                                {/* <div> <strong>₹{Number(newPrice).toFixed(2)}</strong></div> */}
                                            </div>
                                            <div className='subTotal-taxes mt-2 mb-2 d-flex flex-row justify-content-between'>
                                                <div> C-GST ({cgst} %)</div>
                                                <div> +₹{Number(cgstRate).toFixed(2)}</div>
                                            </div>
                                            <div className='subTotal-taxes mt-2 mb-2 d-flex flex-row justify-content-between'>
                                                <div> S-GST ({sgst} %)</div>
                                                <div> +₹{Number(sgstRate).toFixed(2)}</div>
                                            </div>

                                            {/* <div className='subTotal-taxes mt-2 mb-2 d-flex flex-row justify-content-between'>
                                        <div> TCS @10%</div>
                                        <div> +₹{tcsRate}</div>
                                    </div> */}
                                        </div>
                                        <hr className='mt-2 mb-2'></hr>
                                        <div className="total-payable d-flex flex-row justify-content-between gap-3">
                                            <div>Total Payable</div>
                                            <div style={{ color: 'green', fontWeight: '600' }}>₹{Number(grandTotal).toFixed(2)}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* <Modal className='gst-modal' open={priceTableOpen} aria-labelledby="modal-modal-title">
                <Box sx={pricingTableModalStyle}>
                    <Typography className='d-flex flex-row justify-content-between' id="modal-modal-title" variant="h6" component="h2">
                        <div className='d-flex flex-column'>
                            <strong ><span style={{
                                color: "#32325d",
                                textDecoration: "underline",
                                textDecorationColor: "yellow",
                                textDecorationThickness: "2px",
                                textUnderlineOffset: '4px'
                            }}>
                                Detailed
                            </span> tour price</strong>
                            <div style={{ fontSize: '12px', color: '#2d2b29' }}>Prices & discounts are Per Person for Indian Nationals only.</div>
                        </div>

                        <Button sx={{ minWidth: 'unset', position: 'absolute', top: 0, right: 0 }} variant="text" color="inherit" onClick={handleClosePriceTable}>
                            <ClearIcon />
                        </Button>
                    </Typography>
                    <div className="table table-responsive mt-3">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Room Type</th>
                                    <th>Basic Price</th>
                                    <th>Joining/Leaving Price</th>
                                </tr>
                            </thead>
                            <tbody>
                                {packageData && packageData?.roomDetails.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.roomType}</td>
                                        <td>{item.roomPrice}</td>
                                        <td>{item.packageCostForJoinLeave}</td>
                                    </tr>
                                ))}
                                <tr>
                                    <td>Child price</td>
                                    <td>{packageData?.childPrice}</td>
                                    <td>{packageData?.childPrice}</td>
                                </tr>


                            </tbody>
                        </table>
                    </div>
                    <div>
                        <ul>
                            <li>Terms and Conditions apply.</li>
                            <li>5% GST is applicable on given tour price.</li>
                            <li>Mentioned tour prices are Per Person for Indian Nationals only.</li>
                        </ul>
                    </div>

                </Box>
            </Modal> */}
            <div className="modal fade" id="viewPriceModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered">
                    <div className="modal-content modal-content-overflow">
                        <div className="modal-header">
                            <div className="container modal-heading-section">
                                <div className="row">
                                    <div className="d-flex flex-column justify-content-start alig-items-center">
                                        <div style={{ fontSize: '18px', color: '#2d2b29' }}>Detailed tour Price</div>
                                        <div style={{ fontSize: '12px', color: '#2d2b29' }}>Prices & discounts are Per Person for Indian Nationals only.</div>
                                    </div>
                                </div>
                            </div>

                            <button
                                type="button"
                                className="customer-close-btn"
                                onClick={handleCancel}
                                data-bs-dismiss="modal"
                            >
                                {" "}
                                &times;
                            </button>

                        </div>
                        <div className="modal-body">
                            <>
                                <div className="table table-responsive mt-3">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Room Type</th>
                                                <th>Basic Price</th>
                                                <th>Joining/Leaving Price</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {packageData && packageData.roomDetails.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item.roomType}</td>
                                                    <td>{item.roomPrice}</td>
                                                    <td>{item.packageCostForJoinLeave}</td>
                                                </tr>


                                            ))}
                                            <tr>
                                                <td>Child price</td>
                                                <td>{packageData?.childPrice}</td>
                                                <td>{packageData?.childPrice}</td>
                                            </tr>


                                        </tbody>
                                    </table>
                                </div>
                                <div>
                                    <ul>
                                        <li>Terms and Conditions apply.</li>
                                        <li>5% GST is applicable on given tour price.</li>
                                        <li>Mentioned tour prices are Per Person for Indian Nationals only.</li>
                                    </ul>
                                </div>
                            </>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="termsandconditions" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h1 class="modal-title fs-5" id="exampleModalLabel">Terms and Conditions</h1>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <TermsAndConditions />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BookingSummary